import { render } from "./FormStartComponent.vue?vue&type=template&id=26db103e&scoped=true"
import script from "./FormStartComponent.vue?vue&type=script&lang=js"
export * from "./FormStartComponent.vue?vue&type=script&lang=js"

import "./FormStartComponent.vue?vue&type=style&index=0&id=26db103e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26db103e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBanner,QToggle,QSelect,QTooltip});
